import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TipiAltroSoggettoFormComponent } from './dialogs/form/form.component';
import { TipiAltroSoggettoComponent } from './tipi-altro-soggetto.component';


const routes: Routes = [
  {
    path: '', component: TipiAltroSoggettoComponent
  },
  {
    path: 'inserisci', component: TipiAltroSoggettoFormComponent,
    data: { title: 'Inserimento tipi di altro soggetto' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TipiAltroSoggettoRoutingModule { }
